export default function Excel_Format_Painter() {
  return <div>Excel_Format_Painter</div>;
}
